import { Helmet } from "react-helmet";

const HelmetComponent = ({
    title,
    description,
    image,
    url,
}) => {

    const siteTitle =
        title || "Shri Radhe Holidays";

    const siteDescription =
        description ||
        "Book affordable domestic and international tour packages with Shri Radhe Holidays.";

    const siteImage =
        image ||
        "https://www.shriradheholidays.com/logo2.png";

    const siteUrl =
        url ||
        "https://www.shriradheholidays.com";

    return (
        <Helmet>
            {/* Primary SEO */}
            <title>{siteTitle}</title>

            <meta
                name="description"
                content={siteDescription}
            />

            <meta
                name="robots"
                content="index, follow"
            />

            {/* Canonical */}
            <link
                rel="canonical"
                href={siteUrl}
            />

            {/* Open Graph */}
            <meta
                property="og:type"
                content="website"
            />

            <meta
                property="og:title"
                content={siteTitle}
            />

            <meta
                property="og:description"
                content={siteDescription}
            />

            <meta
                property="og:image"
                content={siteImage}
            />

            <meta
                property="og:url"
                content={siteUrl}
            />

            {/* Twitter */}
            <meta
                name="twitter:card"
                content="summary_large_image"
            />

            <meta
                name="twitter:title"
                content={siteTitle}
            />

            <meta
                name="twitter:description"
                content={siteDescription}
            />

            <meta
                name="twitter:image"
                content={siteImage}
            />
        </Helmet>
    );
};

export default HelmetComponent;